var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstaLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "insta-light_2",
    "data-name": "insta-light 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.38 35.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".insta-light-1{fill:#b68a57;stroke-width:0}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "insta-light_1",
    "data-name": "insta-light 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "insta-light-1",
    cx: 17.78,
    cy: 17.67,
    r: 3.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "insta-light-1",
    d: "M21.83 9.25h-8.28c-2.36 0-4.28 1.92-4.28 4.28v8.28c0 2.36 1.92 4.28 4.28 4.28h8.28c2.36 0 4.28-1.92 4.28-4.28v-8.28c0-2.36-1.92-4.28-4.28-4.28zm-4.05 13.52c-2.82 0-5.11-2.29-5.11-5.11s2.29-5.11 5.11-5.11 5.11 2.29 5.11 5.11-2.29 5.11-5.11 5.11zm5.4-9.34c-.67 0-1.22-.54-1.22-1.22s.54-1.22 1.22-1.22 1.22.54 1.22 1.22-.54 1.22-1.22 1.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "insta-light-1",
    d: "M17.69 0C7.92 0 0 7.92 0 17.69s7.92 17.69 17.69 17.69 17.69-7.92 17.69-17.69S27.46 0 17.69 0zm10.37 21.81c0 3.44-2.8 6.23-6.23 6.23h-8.28a6.23 6.23 0 01-6.23-6.23v-8.28a6.23 6.23 0 016.23-6.23h8.28a6.23 6.23 0 016.23 6.23v8.28z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaLight);
export default __webpack_public_path__ + "static/media/insta-light.3d125ceb90510c5daea7923311fe6396.svg";
export { ForwardRef as ReactComponent };